import Vue from "vue";
import Router from "vue-router";
import module from "./module/module";
import cookie from "../api/cookie";
Vue.use(Router);
let router = new Router({
  base: "#",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },




  routes: [


    {
      path: "/",
      component: resolve => require(["@view/login/login_login.vue"], resolve),
      redirect: to =>{
        var logoutURL = sessionStorage.getItem("logout");
        sessionStorage.removeItem("logout");
        if (logoutURL != null && logoutURL != undefined && logoutURL != "/") {
          return logoutURL;
        } else {
          return '/login';
        }
      }
    },
    {
      path: "*",
      component: resolve => require(["@view/masterData/NotFound.vue"], resolve),
      redirect: to =>{
        return '/notfound'; 
      }
    },
    {
      path: "/notfound",
      component: resolve => require(["@view/masterData/NotFound.vue"], resolve)
    },
    {
      path: "/login",
      component: resolve => require(["@view/login/login_login.vue"], resolve)
    },
    {
      name: "forgot",
      path: "/forgot",
      component: resolve => require(["@view/login/forgotPassWord.vue"], resolve)
    },
    {
      path: "/sign",
      component: resolve => require(["@view/login/signupNow.vue"], resolve)
    },
    {
      path: "/page",
      component: resolve => require(["@view/pageIndex/pageIndex.vue"], resolve),
      children: module
    },
    {
      path: "/moose/home",
      component: resolve => require(["@view/moose/home.vue"], resolve),
    },
    {
      path: "/moose/customerInfo",
      component: resolve => require(["@view/moose/customerInfo.vue"], resolve),
    },
    {
      path: "/moose/washing",
      component: resolve => require(["@view/moose/washing.vue"], resolve),
    },
    {
      path: "/moose/scan",
      component: resolve => require(["@view/moose/scan.vue"], resolve),
    },
    {
      path: "/previewImgFile",
      component: resolve => require(["@view/previewImgFile/previewImgFile.vue"], resolve),
    },
    {
      path: "/dashboard/login",
      component: resolve => require(["@view/login/dashboard_login_login.vue"], resolve),
    },
    {
      path: "/dashboard/home",
      component: resolve => require(["@view/dpwDashBoard/dashboardHome.vue"], resolve),
      children: module
    },
    {
      path: "/dashboard/report",
      component: resolve => require(["@view/dpwDashBoard/dashboardReport.vue"], resolve),
      children: module
    },
  ]
});




router.beforeEach((to, from, next) => {

  const publicPaths = [
    '/', '/login', '/forgot', '/sign', '/moose/home', '/moose/washing',
    '/moose/customerInfo', '/moose/scan', '/cfsReceiving', '/notfound',
    '/dashboard/login', '/dashboard/home', '/dashboard/report'
  ];
  if (publicPaths.includes(to.path)) {
    Vue.prototype.$sessionManagerService.stop()
    next();
  } else {
    let token = cookie.getToken()
    if(token == undefined ){
      if(to.path == '/dashboard/home' || to.path == '/dashboard/report') {
        Vue.prototype.$sessionManagerService.stop()
        sessionStorage.removeItem("logout");
        next("/dashboard/login");
      } else {
        Vue.prototype.$sessionManagerService.stop()
        next("/");
      }
    }else{
      Vue.prototype.$sessionManagerService.start()
      next();
    }
  }
});

const isPathDefined = (path) => {
  const matchedRoutes = router.matcher.match(path);
  return matchedRoutes.length > 0;
};
export default router;
